import * as axios from 'axios';

const BASE_URL = 'https://desk.bankpdf.ru/uploaddesk.php';

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: false,
  params: {}
})

instance.interceptors.request.use(function (config) {
  /* global window Store */
  const cookiestring = RegExp("token=[^;]+").exec(document.cookie);
  const token = decodeURIComponent(cookiestring ? cookiestring.toString().replace(/^[^=]+./, "") : "");

  if (token) {
    config.headers.common['Authorization'] = 'Bearer ' + token
    config.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
  } else {
    config.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
  }
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
});

function upload(formData, userId) {
    const url = `${BASE_URL}`;
    return instance.post(url, formData);
}

export { upload }


// WEBPACK FOOTER //
// ./src/utils/file-upload.service.js